module.exports = __webpack_public_path__ + "img/american_credit_demo_video.0fcfab2.png";